import * as Yup from 'yup';

export const additional_interest_validation = Yup.object().shape({
  name_of_interest: Yup.string().required('This field is required!'),
  address_of_interest: Yup.string().required('This field is required!'),
  special_instructions: Yup.string().required('This field is required!'),
});

export const other_validation = Yup.object().shape({
  instructions: Yup.string().required('This field is required!'),
});

export const add_vehicle_or_trailer_validation = Yup.object().shape({
  year: Yup.string().required('This field is required!'),
  make: Yup.string().required('This field is required!'),
  model: Yup.string().required('This field is required!'),
  vin: Yup.string().required('This field is required!'),
  value: Yup.string().required('This field is required!'),
});

export const add_driver_validation = Yup.object().shape({
  first_name: Yup.string().required('This field is required!'),
  last_name: Yup.string().required('This field is required!'),
  date_of_birth: Yup.string(),
  date_of_hire: Yup.string().required('This field is required!'),
  years_of_experience: Yup.string().required('This field is required!'),
  license_number: Yup.string().required('This field is required!'),
  violations: Yup.number().required('This field is required!'),
  accidents: Yup.number().required('This field is required!'),
});
